import { PhaseOfMovement } from '../PhaseOfMovement';

/**
 * Get the color for a given phase of movement
 * Based on utilities.ts:145-177 from main app
 * Colors match the State enum colors from the main UI
 */
export const getStateColor = (movement: PhaseOfMovement | undefined): string => {
  // Handle undefined - grey (State.off)
  if (movement === undefined || movement === PhaseOfMovement.undefined) {
    return 'grey';
  }

  // In-flight phases - green (State.on_and_inflight)
  const inflightPhases = [
    PhaseOfMovement.TakeOff,
    PhaseOfMovement.Ascending,
    PhaseOfMovement.LevelFlight,
    PhaseOfMovement.Descending,
    PhaseOfMovement.Landing,
    PhaseOfMovement.Hover,
    PhaseOfMovement.Moving,
  ];

  if (inflightPhases.includes(movement)) {
    return 'green';
  }

  // Warning state - orange or yellow depending on ground state
  if (movement === PhaseOfMovement.OnGround_with_Warnings) {
    return 'orange';
  }

  // On ground - yellow (State.on_and_stationary)
  return 'yellow';
};

/**
 * Calculate heading from COG, rounded to nearest 5 degrees
 * Based on map-marker-fns.ts:208-219 from main app
 */
export const calculateHeading = (cog: number | null | undefined): number => {
  if (cog == null) {
    return 0;
  }

  // Round to the nearest 5 degree increment
  let rotation = Math.round(cog / 5) * 5;

  // Handle 360 degree wrapping
  return rotation >= 360 ? 0 : rotation;
};
